import React from 'react';

import { MatchObjectNumber } from '../../types';

import styles from '../../styles/LeftMenu.module.scss';

type MatchObjectLabelProps = {
  number: MatchObjectNumber;
  name?: string;
};

const MatchObjectLabel: React.FC<MatchObjectLabelProps> = ({ number, name }) => {
  return (
    <div className={styles.label}
         data-test={`match-object-${number}-label`}>
      {name || '—'}
    </div>
  );
};

export default MatchObjectLabel;
